module.exports = __webpack_public_path__ + "img/story037.63e44fd1.webp";